import { apiSlice } from '../../../api/apiSlice';
import { COACHING_SHOUTOUT_CAROUSEL, COACHING_TODO_STATUS, COACHING_TODO_VIEW, DELETE_COACHING_SHOUTOUT } from '../../../constants';

export const ToDoViewSlice = apiSlice.injectEndpoints({
    endpoints: (builder: any) => ({
        getToDoView: builder.query({
            query: (data: any) => ({
                url: COACHING_TODO_VIEW,
                method: 'GET',
                params: data,
            }),
            providesTags: ["CoachingToDoView"],
        }),
        getShoutOutCarousel: builder.query({
            query: (data: any) => ({
                url: COACHING_SHOUTOUT_CAROUSEL,
                method: 'GET',
                params: data,
            }),
            providesTags: ["CoachingShoutOutCarousel"],
        }),
        updateToDoStatus: builder.mutation({
            query: (data: any) => ({
                url: COACHING_TODO_STATUS,
                method: 'PUT',
                body: data,
            }),
        }),
        deleteShoutOut : builder.mutation({
            query: (arg:any) => ({
                url: DELETE_COACHING_SHOUTOUT,
                method: 'PUT',
                params: {shoutOutId:arg.shoutOutId,modifyBy: arg.employeeNumber},
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                },
            }),
            invalidatesTags: ['CoachingShoutOutCarousel','CoachingShoutOutView'],
        }),
    }),
});

export const { useGetToDoViewQuery, useGetShoutOutCarouselQuery, useUpdateToDoStatusMutation , useDeleteShoutOutMutation} =
    ToDoViewSlice;
